import { CFormInput } from "@coreui/react"
import { IMaskMixin } from 'react-imask'


export const CFormInputWithMaskPhone = IMaskMixin(({ inputRef, ...props }) => (
    <CFormInput placeholder="Номер телефона" {...props} ref={inputRef} />
))
